import React from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../contexts/UserContext";

import { CREATE_WELCOME_MUTATION } from "../../apollo-queries";
import { useMutation } from "@apollo/client";

import { WelcomeText, NavigationText } from "../../Text";
import { Button } from "@mui/base";
import { BsArrowRight } from "react-icons/bs";

type Inputs = {
  name: string;
  email: string;
  company: string;
};

const WelcomeForm: React.FC = () => {
  const [createUser, { loading, error }] = useMutation(CREATE_WELCOME_MUTATION);

  const navigate = useNavigate();
  const { register, handleSubmit } = useForm<Inputs>();

  const { user, setName, setEmail, setCompany, setUUID } = useUser();

  const onSubmit: SubmitHandler<Inputs> = (data) => {
    // Update user context with input data
    setName(data.name);
    setEmail(data.email);
    setCompany(data.company);

    // Create user in database
    createUser({
      variables: {
        name: data.name,
        company_name: data.company,
        email: data.email,
      },
    })
      .then((response) => {
        console.log("User created:", response.data.insert_users);
        console.log(
          "calling setUUID with " +
            response.data.insert_users.returning[0].user_id
        );
        user.uuid = response.data.insert_users.returning[0].user_id;
        setUUID(user.uuid);
        console.log("setUUID called " + user.uuid);
        navigate(`/Instructions/${user.uuid}`);
      })
      .catch((error) => {
        console.error("Error creating user:", error);
      });

    if (loading) {
      return <div>Loading...</div>;
    }
    if (error) {
      return <div>Error: {error.message}</div>;
    }
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="w-2/3 mt-6 mb-20 text-UDig-gray flex flex-col space-y-4"
    >
      {/* Form inputs */}
      <label className="font-semibold text-xl">
        {WelcomeText.name.label}
        <span className="text-red-500 ml-1">*</span>
      </label>
      <input
        {...register("name")}
        className="w-full h-10 px-2 mb-6 border border-light-gray rounded-md"
        required
      />
      <label className="font-semibold text-xl">
        {WelcomeText.email.label}
        <span className="text-red-500 ml-1">*</span>
      </label>
      <input
        {...register("email")}
        className="w-full h-10 px-2 mb-2 border border-light-gray rounded-md"
        required
      />
      <label className="font-semibold text-xl">
        {WelcomeText.company.label}
        <span className="text-red-500 ml-1">*</span>
      </label>
      <input
        {...register("company")}
        className="w-full h-10 px-2 border border-light-gray rounded-md"
        required
      />
      {/* Navigation */}
      <div className="w-full mt-4 flex justify-end text-UDig-orange">
        <Button className="flex items-center gap-x-2" type="submit">
          {NavigationText.next}
          <BsArrowRight />
        </Button>
      </div>
    </form>
  );
};

export default WelcomeForm;
